import { Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { ComponentBase, LanguageInfo, TranslationField } from 't4core';

@Component({
  selector: 't4-translation-editor',
  templateUrl: './t4-translation-editor.component.html',
  styleUrls: ['./t4-translation-editor.component.css']
})
export class T4TranslationEditorComponent extends ComponentBase implements OnInit, OnChanges {
  public selectedTranslationField: TranslationField | undefined;

  @Input() translationKey: string = "";
  @Input() canEditTranslation: boolean = true;
  @Input() placeholderMessage: string = "";
  @Input() selectedLanguage: string = 'en';
  @Input() languages: LanguageInfo[] = [];
  @Input() translationFields: TranslationField[] = [];
  @Input() showUnverified: boolean = false;
  @Input() isTranslationView: boolean = false;
  @Input() minWidthPx: number = 0;

  @Output() translationChanged = new EventEmitter<string>();
  constructor() {
    super();
  }

  public async ngOnInit() {
    //Get the languages from Api if no language was passed from the input.
    if (!this.languages || this.languages.length < 1) {
      await this.getLanguages();
    }

    //Get the translation fields only if no data was passed from the input.
    if (!this.translationFields || this.translationFields.length < 1) {
      await this.getTranslations();
    }
    else {
      if (this.selectedLanguage) {
        this.setSelectedLanguageValue();
      }
    }
  }

  public async getLanguages() {
    this.languages = await this.Api.get<LanguageInfo[]>("Settings/GetLanguages");
  }

  public async getTranslations() {
    this.translationFields = await this.Api.get<TranslationField[]>("Settings/GetAllLanguageTranslationsForKey", { translationKey: this.translationKey });
    if (this.selectedLanguage) {
      this.setSelectedLanguageValue(); 
    }
  }

  public async saveTranslations() {
    var ret = await this.Api.post<boolean>("Settings/SaveAllLanguageTranslationsForKey", this.translationFields);
    if (ret) {
      await this.getTranslations();
    }
  }

  setSelectedLanguageValue() {
    if (this.selectedLanguage && this.translationFields.length > 0) {
      const validLanguageCodes = this.filteredLanguages.map(l => l.Code);
      if (!validLanguageCodes.includes(this.selectedLanguage)) {
        this.selectedLanguage = validLanguageCodes[0] ?? '';
      }
      this.selectedTranslationField = this.translationFields.find(field => field.Language === this.selectedLanguage);
    }
  }

  getSelectedLanguage() {
    return this.languages.find(lang => lang.Code === this.selectedLanguage);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedLanguage'] && !changes['selectedLanguage'].firstChange) {
      this.setSelectedLanguageValue(); 
    }
  }

  onValueChanged() {
    if (this.selectedTranslationField) {
      this.selectedTranslationField.IsVerified = true;
      if (this.isTranslationView) {
        this.translationChanged.emit(this.translationKey);
      }
    }
  }
  onCheckboxToggled() {
    if (this.selectedTranslationField && this.isTranslationView) {
      this.translationChanged.emit(this.translationKey);
    }
}

  get filteredLanguages(): LanguageInfo[] {
    if (!this.isTranslationView || !this.showUnverified) return this.languages;

    const unverifiedLangCodes = this.translationFields
      .filter(t => !t.IsVerified)
      .map(t => t.Language);

    return this.languages.filter(lang => unverifiedLangCodes.includes(lang.Code));
  }
}
